import React, { useState } from "react";
import { Modal } from "react-bootstrap";

function Maintenance() {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      centered
      size="lg"
      backdrop={true}   // closes when clicking outside
      keyboard={true}   // closes when pressing ESC
    >
      <Modal.Header
        closeButton   // ✅ adds close (X) icon
        style={{
          backgroundColor: "#FFCC01",
          color: "#055837"
        }}
      >
        <Modal.Title className="mx-auto d-block">
          <h5 className="modal-title text-uppercase text-center" id="exampleModalLabel"
          style={{ marginLeft: "180px" }}
          >
            <b>Important Notice</b>
          </h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div
            className="col-12 custom_text text-uppercase text-center"
            style={{ fontWeight: "bold", fontSize: "15px" }}
          >
            <h5>
              
              The Portal will be under maintenance from:
              <br/>
              <br/>
              <b>
              06:00 PM (AEDT) Saturday, 7<sup><span className="text-lowercase">th</span></sup> Feb 2026
              </b>
              <br/>
              <b>
              TO
              </b>
              <br />
              <b>
              06:00 AM (AEDT) Sunday, 8<sup><span className="text-lowercase">th</span></sup> Feb 2026
              </b>
              <br />
              <br />
              We Apologize for any inconvenience it may cause
              <br/>
              <br/>
            </h5>
            <h6 style={{ fontWeight: "bold" }}>Team AQATO – ATTC</h6>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Maintenance;
